import { MissingComponentWarning } from "core/MissingComponentWarning";
import React from "react";
import { objectPropertiesToArray } from "../utils/utils";
import { ComponentTypeMappings } from "./component-mappings";
import { ComponentTypeWithID, IComponentType, IComponentTypeMapping } from "./ComponentTypeTypes";
import { DashboardComponentType } from "api/model/dashboard/DashboardComponent";

export function getComponentModule(type: DashboardComponentType) {
  const cType = getComponentType(type);
  if (cType) {
    return cType.entryPoint();
  }

  return null
}

export function getComponentModuleOrMissing(type: DashboardComponentType) {
  const module = getComponentModule(type);
  if (module) {
    return module;
  }

  return <MissingComponentWarning componentId={type as string} />;
}

export function getComponentType(type: DashboardComponentType): IComponentType | undefined {
  if (!(type in ComponentTypeMappings)) {
    console.warn(`Can't get component type for ${type}`);
    return undefined;
  }

  return ComponentTypeMappings[type as keyof IComponentTypeMapping];
}

export function getDashboardComponentTypes(): ComponentTypeWithID[] {
  return objectPropertiesToArray(ComponentTypeMappings).filter(
    type => type.dashboardComponent
  ) as ComponentTypeWithID[];
}
